import React, { useState, useEffect } from "react";
import Vapi from "@vapi-ai/web";

const VAPI_PUBLIC_KEY = "77d83bca-305f-40a9-9731-705a53f2b492"; // Replace with your actual Vapi public key
const ASSISTANT_ID = "098dd4c1-c851-4a88-b181-985457a410b0"; // Replace with your assistant ID

function App() {
  const [vapi, setVapi] = useState(null);
  const [callActive, setCallActive] = useState(false);

  useEffect(() => {
    // Initialize Vapi instance when component mounts
    const vapiInstance = new Vapi(VAPI_PUBLIC_KEY);
    setVapi(vapiInstance);

    vapiInstance.on("call-start", () => {
      console.log("Call started");
      setCallActive(true);
    });

    vapiInstance.on("call-end", () => {
      console.log("Call ended");
      setCallActive(false);
    });

    return () => {
      vapiInstance.removeAllListeners(); // Cleanup event listeners on unmount
    };
  }, []);

  const handleCall = async () => {
    if (!vapi) {
      console.error("Vapi instance is not initialized yet.");
      return;
    }

    if (callActive) {
      // Stop the call using Vapi's official method
      console.log("Ending call...");
      await vapi.stop();
    } else {
      // Start a new call
      console.log("Starting call...");
      await vapi.start(ASSISTANT_ID);
    }
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>Call Spelling Tutor</h1>
      <button
        onClick={handleCall}
        style={{
          padding: "10px 20px",
          fontSize: "16px",
          backgroundColor: callActive ? "#f44336" : "#4CAF50",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          marginTop: "20px",
        }}
      >
        {callActive ? "End Call" : "Start Call"}
      </button>
    </div>
  );
}

export default App;
